<template>
  <v-container 
  v-if="isDataReady"
  fluid>
    <section-title-with-request-id
    :request-id="remoteSupportProp.requestId"
    title="pages.remoteSupport.repairRequestDetails"
    :subtitle="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR']) ? 'pages.remoteSupport.pleaseApproveOrRejectDetailTab' : null"
    subtitle-bold
    class="mb-3"/>

    <updatable-status-by-admin
    :data="remoteSupportProp"
    :loading="isLoading"
    :statusesFetcher="getPartRequestStatuses"
    :statusGetter="getStatusAsObject"/>
    <v-row dense class="mt-10">
      <v-col>
        <span class="process-repair-tab-section-title text-uppercase">{{$t('pages.remoteSupport.dataForApproval')}}</span>
      </v-col>
      <v-col
      v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR'])"
      class="d-flex justify-end">
        <approval-comment-dialog-trigger
        @click="openApprovalCommentDialogForRequest"
        :value="newData.approvalComments['INITIAL']"
        :disable-on-empty="disabled"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <approval-comment-dialog
        v-if="approvalCommentDialog.model"
        v-model="approvalCommentDialog.model"
        :comment="approvalCommentDialog.comment"
        :status="approvalCommentDialog.status"
        :step-status="remoteSupportProp.status.key"
        :owner-id="approvalCommentDialog.ownerId"
        :saver="approvalCommentDialog.saver"
        @success="onApprovalCommentSaved"
        :preview="disabled"/>
        <new-remote-support
        :preview-data="newData"/>
      </v-col>
    </v-row>
    <v-row 
    v-if="$parent.isRole(['ADMIN', 'SUPER_ADMIN', 'SUPERVISOR'])"
    class="mt-5"
    dense>
      <v-col>
        <process-repair-quick-btns
        :config="getQuickBtnsConfig"
        :loading.sync="isLoading"
        title="common.pressContinueWhenReady"
        on-success-repair-status-message="dialogs.messages.success.remoteSupportFirstDetailsCompleted"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ProcessRepairQuickBtns from '@/components/process-repair-tabs/ProcessRepairQuickBtns'
import UpdatableStatusByAdmin from '@/components/common/process-tabs/UpdatableStatusByAdmin'
import NewRemoteSupport from '@/pages/remote-support/NewRemoteSupport'
import ApprovalCommentDialog from '@/components/dialogs/ApprovalCommentDialog'
import ApprovalCommentDialogTrigger from '@/components/common/triggers/ApprovalCommentDialogTrigger'
import SectionTitleWithRequestId from '@/components/common/process-tabs/shared/SectionTitleWithRequestId'
import { getObjectRemoteSupportStatusByKey, getAvailableRemoteSupportStatuses,  } from '@/utils/statusesUtil'
import { execHttpRequestThrowable } from '@/services/http'
import { updateInitialApproval } from '@/repositories/supportRepo'
import { copyObj } from '@/utils/StringUtil'
import { getTime } from '@/utils/DateUtil'
import { saveRequestApprovalComment } from "@/repositories/supportRepo"

export default {
  name: 'DetailsTabRemoteSupport',
  components: {
    ProcessRepairQuickBtns,
    UpdatableStatusByAdmin,
    NewRemoteSupport,
    ApprovalCommentDialog,
    ApprovalCommentDialogTrigger,
    SectionTitleWithRequestId
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: Boolean
  },
  data() {
    return {
      newData: null,
      isLoading: false,
      isDataReady: false,
      approvalCommentDialog: {
        model: false,
        comment: null,
        status: null,
        ownerId: -1,
        isItem: false,
        saver: null
      }
    }
  },
  computed: {
    remoteSupportProp: {
      get: function() {
        return this.$props.data
      },
      set: function(v) {
        this.$emit('update:data', v)
      }
    },
    getQuickBtnsConfig() {
      return [
        {
          name: 'Reject',
          events: {
            'click': () => this.tryToChangeInitialStatus('REJECTED')
          },
          props: {
            'disabled': this.disabled || this.newData.initialApproval === 'REJECTED'
          }
        }, {
          name: 'Approve',
          events: {
            'click': () => this.tryToChangeInitialStatus('APPROVED')
          },
          props: {
            'disabled': this.disabled || this.newData.initialApproval === 'APPROVED'
          }
        }, {
          name: 'Continue',
          props: {
            'disabled': this.disabled || !this.newData.isAllowedToContinue
          }
        }
      ]
    }
  },
  methods: {
    async tryToChangeInitialStatus(status) {
      const r = await execHttpRequestThrowable(async () => await updateInitialApproval(this.$route.params.id, status), {}, v => this.isLoading = v)
      this.newData.initialApproval = String(status)
      this.remoteSupportProp.initialApproval = String(status)
      this.newData.isAllowedToContinue = r.response.data
      this.$snackbar.success('snackbar.success.initialApprovalSaved', {value: status})
    },
    getPartRequestStatuses() {
      return getAvailableRemoteSupportStatuses()
    },
    getStatusAsObject(s) {
      return getObjectRemoteSupportStatusByKey(s)
    },
    openApprovalCommentDialogForRequest() {
      this.approvalCommentDialog = {
        model: true,
        comment: this.newData.approvalComments['INITIAL'],
        status: this.newData.initialApproval,
        ownerId: Number(this.$route.params.id),
        saver: saveRequestApprovalComment
      }
    },
    onApprovalCommentSaved({comment}) {
      //Update server parts
      this.remoteSupportProp.approvalComments["INITIAL"] = comment
      //Update local parts
      this.newData.approvalComments["INITIAL"] = comment

      this.approvalCommentDialog.model = false
    },
  },
  mounted() {
    this.newData = copyObj(this.remoteSupportProp)
    this.newData.isAllowedToContinue = this.remoteSupportProp.isAllowedToContinue
    this.newData.preferredTime = getTime(new Date(this.newData.preferredDate))
    this.newData.preferredDate = this.newData.preferredDate.replaceAll(/T.*$/g, '')
    this.isDataReady = true
  }
}
</script>
<style>

</style>